import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { call, takeEvery } from 'redux-saga/effects';
import { cmsWebContent } from 'redux/saga/entities/bound';
import { isEmpty } from 'helpers/verify';
import { doLoadCmsModules } from './cms-modules.saga';

export const loadCmsContent = (slugs, options = {}) => ({ type: 'LOAD_CMS_CONTENT', slugs, ...options });

export function* doLoadCmsContent(client, { slugs }) {
  try {
    let cmsData = {};
    if (!isEmpty(slugs)) {
      cmsData = yield call(fetchEntityIfNeeded, cmsWebContent, [client, slugs[0]]);
      yield call(doLoadCmsModules, client, cmsData);
    }
    return cmsData;
  } catch (error) {
    if (error.code === 404) {
      // continue fetching until a matching slug is found
      yield call(doLoadCmsContent, client, { slugs: slugs.slice(1) });
    } else {
      throw error;
    }
  }
}

export function* watchCmsContentSagas(client) {
  yield takeEvery(loadCmsContent().type, doLoadCmsContent, client);
}
